<template>
    <button class="btn btn-default" 
        type="button"
        @click.prevent="e => $emit('click', e)"
        :disabled="disabled">
        <i :class="`fa fa-${icon}`" v-if="Boolean(icon)" /> {{ label }}
    </button>
</template>

<script>
export default {
    props: {
        disabled: {
            type: Boolean,
            required: false,
            default: false,
        },
        icon: {
            type: String,
            required: false,
            default: 'plus',
        },
        label: {
            type: String,
            required: false,
            default: 'Tambah',
        },
    }
}
</script>